import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=7169ae32&scoped=true&"
import script from "./TagInput.vue?vue&type=script&lang=js&"
export * from "./TagInput.vue?vue&type=script&lang=js&"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=7169ae32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7169ae32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCombobox,VTextField})
